export const MAX_CREATE_TEMPLATE_COPY_ATTEMPTS = 5;
